import { z } from "zod";

const historyNoteSchema = z
  .string()
  .max(1000, "Notes must be 1000 characters or less");

const clientAppointmentHistoryItemSchema = z.object({
  id: z.number(),
  colour_notes: historyNoteSchema,
  cut_notes: historyNoteSchema,
  product_notes: historyNoteSchema,
  conversation_notes: historyNoteSchema,
});

export const clientAppointmentHistorySchema = z.object({
  items: z.array(clientAppointmentHistoryItemSchema),
});

export type ClientAppointmentHistoryFormValues = z.infer<
  typeof clientAppointmentHistorySchema
>;
